/**
 * Created by sn on 20.11.2017.
 */

import parent from '../../wgg/wgg.module';
import ol from 'openlayers';

parent.factory('mapOptions', mapOptions);

function mapOptions() {

    var mapOptionsAPI = {
        baseLayer: 'basemap_lite',
        labelLayer: 'basemap_labels',
        satelliteLayer: 'basemap_ortho',
        attribution: 'Datenquelle: basemap.at, wien.gv.at',
        mapOpts: {
            target: "olmap",
            loadTilesWhileInteracting: true,
            loadTilesWhileAnimating: true,
            layers: [],
            renderer: ['canvas', 'dom', 'webgl']
        },

        viewOpts: {
            projection: 'EPSG:3857',
            displayProjection: 'EPSG:4326',
            center: ol.proj.transform([13, 47], 'EPSG:4326', 'EPSG:3857'),
            zoom: 5,
            minZoom: 0,
            maxZoom: 19
        },

        bbox: [1805042.4840063362, 6128189.459703162, 1839739.0398469304, 6154942.220734292]
    };

    return mapOptionsAPI;

}



// WEBPACK FOOTER //
// ./src/components/map/mapOption.service.js